import React, { useContext } from 'react';

import Alert from 'kingpin/Alert';
import Typography from 'kingpin/atoms/Typography';

import { AdditionalPaymentsModeContext } from './AdditionalPaymentsModeProvider';
import AdditionalPaymentsSummary from './AdditionalPaymentsSummary';
import PaymentRow from './PaymentRow';

// The manage view's body: the budget and the record's payments, each with
// Remove. Removing the last one leaves the mode (see the provider).
const ManageAdditionalPayments = ({
  bonusOverview,
  response,
}: {
  bonusOverview: BonusTypes.BonusOverview;
  response: BonusTypes.AdditionalPayments.Response;
}) => {
  const { removingPaymentId, removePayment, serverError } = useContext(
    AdditionalPaymentsModeContext,
  );

  return (
    <>
      <AdditionalPaymentsSummary
        bonusOverview={bonusOverview}
        response={response}
      />
      {response.payments.length === 0 && (
        <Typography.Body type={'Body 13'}>
          {'This driver has no additional payments for this period.'}
        </Typography.Body>
      )}
      {response.payments.map((payment) => (
        <PaymentRow
          key={payment.id}
          payment={payment}
          onRemove={removePayment}
          isRemoving={removingPaymentId === payment.id}
          isRemoveDisabled={!!removingPaymentId}
        />
      ))}
      {serverError && (
        <div style={{ marginTop: 16 }}>
          <Alert type={'Danger'} body={serverError} />
        </div>
      )}
    </>
  );
};

export default ManageAdditionalPayments;
